import { useGetQuery, useLazyGetQuery, usePostMutation } from "slices/api";
import {
  AUDIT_SCHEDULE,
  FIRE_SAFETY_APPLICATION,
  REGISTER_BUILDING,
} from "tagTypes";

export const useGetAllFireSafetyApplicationsQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/building-information",
    query,
    tags: [REGISTER_BUILDING, FIRE_SAFETY_APPLICATION],
  });

export const useGetFireSafetyApplicationDetailQuery = (
  buildingInformationId,
  query = {}
) =>
  useGetQuery({
    endpoint: `/building-information/${buildingInformationId}`,
    query,
    tags: [REGISTER_BUILDING, FIRE_SAFETY_APPLICATION],
  });

export const useGetFireSafetyApplicationUpdateTrackingQuery = (
  buildingInformationId,
  query = {}
) =>
  useGetQuery({
    endpoint: `/building-information/${buildingInformationId}/tracking`,
    query,
    tags: [REGISTER_BUILDING, FIRE_SAFETY_APPLICATION],
  });

export const useLazyGetFireApplicationDetailQuery = () => {
  const [applicationDetails, data] = useLazyGetQuery();
  const applicationDetail = async (buildingInformationId, query = {}) =>
    await applicationDetails(
      {
        endpoint: `/building-information/${buildingInformationId}`,
        query,
        tags: [REGISTER_BUILDING, FIRE_SAFETY_APPLICATION],
      },
      true
    ).unwrap();
  return [applicationDetail, data];
};

export const usePostFireApplicationDetailsMutation = () => {
  const [applicationDetails, data] = usePostMutation();
  const applicationDetail = async (payload, query = {}) =>
    await applicationDetails({
      endpoint: "/building-information",
      query,
      payload: payload || {},
      toastMessage: "Application request added successfully",
      tags: [REGISTER_BUILDING, FIRE_SAFETY_APPLICATION],
    }).unwrap();
  return [applicationDetail, data];
};

export const usePostUploadAuditCalendarMutation = () => {
  const [uploadCalendar, data] = usePostMutation();
  const uploadCalendarFile = async (payload) =>
    await uploadCalendar({
      endpoint: "/schedule/upload",
      payload: payload || {},
      toastMessage: "Calendar uploaded successfully",
      tags: [AUDIT_SCHEDULE, FIRE_SAFETY_APPLICATION],
    }).unwrap();
  return [uploadCalendarFile, data];
};
